// extracted by mini-css-extract-plugin
export default {"container":"tire-wheel-package-status__container___jaBfx"};